import { resetLocalCacheKey, setShipTo } from '@vivino/js-web-common';
import {
  getCurrentCountryCode,
  getDefaultStateForCountry,
  isStatePathSupported,
} from 'vivino-js/helpers/countryHelpers';
import { isI18nPath, replaceI18nFromUrl } from 'vivino-js/helpers/pathHelper';
import { i18nRootUrl } from 'vivino-js/vivinoUrls';

const usStates = globalThis.__PRELOADED_STATE__?.usStates || {};

export const getShippingZip = () => {
  return globalThis.__PRELOADED_SHIPPING_ZIP_CODE__ || null;
};

export const getShippingZipPrefill = () => {
  return globalThis.__PRELOADED_SHIPPING_ZIP_PREFILL__ || null;
};

export const getShipToUsState = (state) =>
  Object.keys(usStates).find((key) => usStates[key] === state);

export const changeShipTo = async ({ countryCode = getCurrentCountryCode(), stateCode }) => {
  await setShipTo(countryCode, stateCode);
  resetLocalCacheKey();
  if (isI18nPath()) {
    replaceCurrentI18nPath(countryCode, stateCode);
  } else {
    location.reload();
  }
};

function replaceCurrentI18nPath(countryCode, stateCode) {
  const newState = isStatePathSupported(countryCode)
    ? stateCode || getDefaultStateForCountry(countryCode)
    : null;

  const newUrl = replaceI18nFromUrl(
    globalThis.location.href,
    i18nRootUrl({ countryCode, stateCode: newState })
  );

  globalThis.location.assign(newUrl);
}
